import ApiService from './ApiService'

export const getApiData = data => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map(sort => {
            if (!sort.dir) return sort
            datas.ordering = sort.dir === 'desc' ? `-${sort.column}` : `${sort.column}`
            return sort
        })
        if (data?.query) {
            datas.search = data.query
        }
        if (data?.selectedTab) {
            datas.is_active = data.selectedTab === 'active'
        }
        if (data?.category) {
            datas.category = data.category
        }
        if (data?.company) {
            datas.company_id = data?.company
        }
        if (data?.customer) {
            datas.customer_id = data?.customer
        }
    }
    return ApiService.get('/api/v1/report-management/reports/', datas)
}
export const createApiRecord = data => ApiService.post('/api/v1/report-management/reports/', data)
export const createApiMask = id => ApiService.post(`/api/v1/report-management/reports/${id}/generate_masked_url/`)
export const getApiRecord = id => ApiService.get(`/api/v1/report-management/reports/${id}/`)
export const updateApiRecord = (id, data) => ApiService.patch(`/api/v1/report-management/reports/${id}/`, data)
export const deleteApiRecord = id => ApiService.delete(`/api/v1/report-management/reports/${id}/`)
export const getApiReport = url => ApiService.get(`/api/v1/report-management${url}`)
